import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../admin/common/loader";
import { formateDate, formateDateWithMonth } from "../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import { Details } from "../../admin/services/userSubscription.service";
import Breadcrums from "../../admin/common/breadcrumbs";
import { Placeholder} from "rsuite";

const UserSubscriptionDetailView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("label_user_subscriptions"),
      url: "/admin/subscription/user-subscription-plan/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];


  useEffect(() => {
    Details(params._id)
      .then((response) => {
        // console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params._id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
               <div>
                <h6 className="main-content-label mb-3">{t("btn_view") + " " + t("label_subscription_detail")}</h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                    
                        <tr>
                          <th>{t("label_name")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.userDetails && showdefault.userDetails.fullName
                              ? showdefault.userDetails.fullName
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_email")}</th>
                          <td>
                          {showdefault && showdefault.userDetails && showdefault.userDetails.email
                              ? showdefault.userDetails.email
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_type")}</th>
                          <td>
                          {showdefault && showdefault.subscriptionPlanDetail && showdefault.subscriptionPlanDetail.name
                              ? showdefault.subscriptionPlanDetail.name
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("list_heading_status")}</th>
                          <td className="text-capitalize">
                            {showdefault && (showdefault.cancelScheduled || showdefault.status === "cancelled" ? "Cancelled" : showdefault.status || "N/A")}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_price")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.subscriptionPrice 
                              ? `$${showdefault.subscriptionPrice}`
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_plan_validity")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.planValidity 
                              ? `${showdefault.planValidity}`
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_cancel_scheduled")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.cancelScheduled.toString()==='true' 
                              ? 'Yes'
                              : "No"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.startDate 
                              ? `${formateDateWithMonth(showdefault.startDate)}`
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("list_heading_expire_date")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.endDate 
                              ? `${formateDateWithMonth(showdefault.endDate)}`
                              : "N/A"}
                          </td>
                        </tr>




                       


              

                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                 <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              )}
            </div>

            <div className="mt-2 back-button mx-4">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/subscription/user-subscription-plan/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserSubscriptionDetailView;
